import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { media } from '../utils/media';

import { Image } from 'components';

const SectionCompare = ({ title, textUk, textSe, textEn, image, imageAlt, icon, alt, reverse, className, locale}) => {

  return (
      <div className={cx('compare-wrapper', { reverse }, [className])}>
        <div className='section-text'>
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
          {textUk && locale === 'uk' ? <p>{textUk}</p> : '' }
          {textEn && locale === 'en' ? <p>{textEn}</p> : '' }
          {textSe && locale === 'se' ? <p>{textSe}</p> : '' }
          {!textEn && !textSe && locale !== 'uk' ? <p>{textUk}</p> : '' }
        </div>
        <div className='section-media'>
          <Image url={media(image)} alt={imageAlt} />
          <Image url={media(icon)} alt={alt} className='icon-wrapper' />
        </div>
      </div>
    );
  }

SectionCompare.propTypes = {
  title: PropTypes.string.isRequired,
  textUk: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  reverse: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};

SectionCompare.defaultProps = {
  reverse: false,
  className: '',
};

export default SectionCompare;
